export default __webpack_public_path__ + "28e34da017ba0bc5bb79957b469bf822.svg";